/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import { styled, css } from 'fierry/react.old';

import Center from 'astro/react/map/zone/center';
import Background from 'astro/react/map/dock/background';
import Border from 'astro/react/map/dock/border';


export default (props) =>
(
  <Center {...props} >

    <Background {...props} />
    <Border {...props} />

  </Center>
);
